export default __webpack_public_path__ + "static/media/offing-sarah-ghazal-ali.7430f04c.webp";